export function getItemsInRow(gridWidth: number, itemWidth: number, gap: string) {
  return Math.max(1, Math.floor(gridWidth / (itemWidth + parseInt(gap))));
}

export function getVirtuosoHeight(itemsLength: number, gridWidth: number, itemWidth: number, gap: string) {
  if (!itemsLength || !gridWidth) return { height: 0, initialItemCount: 0, itemsInRow: 0 };

  const itemHeight = Math.ceil(itemWidth * 2.5);
  const itemsInRow = getItemsInRow(gridWidth, itemWidth, gap);
  const rowCount = Math.min(Math.ceil(itemsLength / itemsInRow), 2);

  return { height: rowCount * itemHeight, itemsInRow, initialItemCount: itemsInRow * rowCount };
}
